





































import Vue from 'vue';
import Component from 'vue-class-component';
import { ProvideReactive, Prop, Ref } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

// Store types
import { SpacesGetter, SystemsGetter, ToolSpace, ToolSystem } from '@/store/store.types';

// Internal components
import OverviewSystemHeading from './OverviewSystemHeading.vue';
import OverviewSystemUnits from './units/OverviewSystemUnits.vue';
import OverviewSystemAccessories from './accessories/OverviewSystemAccessories.vue';

/**
 *  Component that renders the overview system, including his heading, units, accessories and footer.
 */
@Component({
    components: {
        OverviewSystemHeading,
        OverviewSystemUnits,
        OverviewSystemAccessories,
    },
})
export default class OverviewSystem extends Vue {

    @Ref('accessories')
    private accessories!: OverviewSystemAccessories;

    @ProvideReactive('toolSpaceId')
    @Prop({ type: String, required: true })
    private toolSpaceId!: string;

    @ProvideReactive('toolSystem')
    @Prop({ type: Object, required: true })
    private toolSystem!: ToolSystem;

    /**
     *  Holding the mounted state of the component,
     *  used to let the `totalPrice` work.
     */
    private isMounted = false;

    /**
     *  Get and provide the (tool) spaces for which the system is rendered.
     */
    @ProvideReactive('toolSpaces')
    private get toolSpaces(): Array<ToolSpace> {

        const spaces: Array<ToolSpace> = [];

        for (const toolSpaceId of this.toolSpaceId.split('-')) {

            spaces.push(this.$store.getters[SpacesGetter.ADDED][toolSpaceId]);

        }

        return spaces;

    }

    /**
     *  Get and provide the (data of the) system to every component.
     */
    @ProvideReactive('system')
    private get system(): System {

        return this.$store.getters[SystemsGetter.SUGGESTIONS_SYSTEMS][this.toolSystem.guid];

    }

    /**
     *  Used to get the fact if the accessories should be
     *  rendered: if the system includes accessories.
     */
    private get renderAccessories(): boolean {

        return Array.isArray(this.system.accessories) && !!this.system.accessories.length;

    }

    /**
     *  Used to get the total price of the overview system, including
     *  the price of the system and the prices of the accessories.
     */
    private get totalPrice(): number {

        let total = 0;

        /**
         *  Only compute if mounted, because otherwise the
         *  `OverviewSystemAccessories` component isn't added to
         *  the DOM - making it impossible to get
         *  the prices of the accessories.
         */
        if (!this.isMounted) {

            return total;

        }

        /**
         *  Add the price of the system.
         */
        total += this.system.price || 0;

        /**
         *  Add the total price of all accessories if present.
         */
        if (this.accessories) {

            total += this.accessories.accessoriesPrice;

        }

        return total;

    }

    /**
     *  Update the mounted state, so the `totalPrice`
     *  getter can start working.
     */
    private mounted(): void {

        this.isMounted = true;

    }

}
